<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'발송 대량 업로드'"
      :modal="true"
      :width="'500px'"
      style="display:none;"
  >
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <ul>
            <li class="mgt10">
              <span>발송 <b>취급구분</b>을 선택한 후 대량 업로드를 진행해 주세요.</span>
              <div class="box_flex mgt10">
                <button type="button" class="mid_btn mr5 w30" @click="onSelect('01')"><span>등기</span></button>
                <button type="button" class="mid_btn mr5 w30" @click="onSelect('03')"><span>해외 특송</span></button>
                <button type="button" class="mid_btn w35" @click="onSelect('02')"><span>택배</span></button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </kendo-window>
</template>

<script>
export default {
  name: 'SelectSendScnWindow',
  methods: {
    onSelect (sendScn) {
      const vm = this
      vm.$emit('onSelect', sendScn)
      vm.$refs.kendoWindowRef.kendoWidget().close()
    }
  }
}
</script>
<style scoped>
</style>
